import {
  LayoutDashboard,
  UserPlus,
  IndianRupee,
  Database,
  ClipboardList,
  Package,
  Share2,
  FileDown,
  Calculator,
  Settings as SettingsIcon,
  LogOut,
} from "lucide-react";

const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_sales-velocity-43/artifacts/nh1fjaiq_Copy%20of%20ZEESHAN%20TECHBORN%20CARD-2.png";

const MAIN = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { key: "entry", label: "Lead Entry", icon: UserPlus },
  { key: "library", label: "Lead Library", icon: Database },
  { key: "closing", label: "Direct Closing", icon: IndianRupee },
  { key: "orders", label: "Current Orders", icon: ClipboardList },
  { key: "products", label: "Products", icon: Package },
  { key: "sharekit", label: "Product Library", icon: Share2 },
];

const SECONDARY = [
  { key: "reports", label: "Reports", icon: FileDown },
  { key: "commission", label: "Commission", icon: Calculator },
  { key: "settings", label: "Settings", icon: SettingsIcon },
];

export default function Sidebar({ view, setView, leadsCount, mobileOpen, setMobileOpen, user, isOwner, onLogout }) {
  const go = (key) => {
    setView(key);
    setMobileOpen && setMobileOpen(false);
  };
  const renderItem = (item) => {
    const Icon = item.icon;
    const active = view === item.key;
    return (
      <button
        key={item.key}
        data-testid={`nav-${item.key}`}
        onClick={() => go(item.key)}
        className={`nav-item w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm ${
          active
            ? "bg-blue-50 text-blue-700 font-semibold"
            : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
        }`}
      >
        <Icon size={18} strokeWidth={active ? 2.4 : 2} />
        <span className="font-body">{item.label}</span>
        {item.key === "library" && (
          <span
            data-testid="sidebar-leads-count"
            className="ml-auto text-[11px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 font-semibold"
          >
            {leadsCount}
          </span>
        )}
      </button>
    );
  };
  return (
    <>
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-slate-900/40 z-40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}
      <aside
        data-testid="app-sidebar"
        className={`w-64 flex-shrink-0 border-r border-slate-200 bg-white flex flex-col fixed inset-y-0 left-0 z-50 transform transition-transform md:static md:translate-x-0 ${
          mobileOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
      <div className="px-5 py-5 border-b border-slate-100">
        <div className="flex items-center gap-3">
          <div
            data-testid="brand-logo"
            className="w-11 h-11 rounded-lg overflow-hidden bg-white ring-1 ring-slate-200 flex items-center justify-center shadow-sm"
          >
            <img
              src={LOGO_URL}
              alt="Techborn Ventures"
              className="w-full h-full object-contain"
            />
          </div>
          <div>
            <div className="font-heading text-[15px] font-bold text-slate-900 tracking-tight leading-tight">
              Techborn Ventures
            </div>
            <div className="text-[10px] uppercase tracking-[0.16em] text-red-600 font-bold">
              Private Limited
            </div>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">{MAIN.map(renderItem)}</nav>

      <div className="px-3 py-3 border-t border-slate-100 space-y-1">
        {SECONDARY.filter((i) => i.key !== "settings" || isOwner).map(renderItem)}
      </div>

      <div className="px-4 py-4 border-t border-slate-100 space-y-3">
        <div className="rounded-lg bg-slate-900 text-white p-4">
          <div className="text-[11px] uppercase tracking-[0.14em] text-slate-400 font-semibold">
            Live pipeline
          </div>
          <div className="font-heading text-xl font-bold mt-1">
            {leadsCount} leads
          </div>
          <div className="text-xs text-slate-400 mt-1">
            Real-time · synced now
          </div>
        </div>
        {user && (
          <div data-testid="sidebar-user" className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-full overflow-hidden bg-slate-100 ring-1 ring-slate-200 flex items-center justify-center text-slate-500 shrink-0">
              {user.picture ? (
                <img src={user.picture} alt={user.name} className="w-full h-full object-cover" />
              ) : (
                <span className="text-xs font-bold">
                  {(user.name || user.email || "?").slice(0, 1).toUpperCase()}
                </span>
              )}
            </div>
            <div className="min-w-0 flex-1">
              <div data-testid="sidebar-user-name" className="text-[13px] font-semibold text-slate-900 truncate">
                {user.name || user.email}
              </div>
              <div
                className={`text-[10px] uppercase tracking-wide font-bold ${
                  isOwner ? "text-red-600" : "text-slate-400"
                }`}
              >
                {isOwner ? "Owner" : "Member"}
              </div>
            </div>
            <button
              data-testid="logout-btn"
              onClick={onLogout}
              title="Sign out"
              className="p-2 text-slate-400 hover:text-rose-600 rounded-md"
              style={{ transition: "color 160ms ease" }}
            >
              <LogOut size={16} />
            </button>
          </div>
        )}
      </div>
    </aside>
    </>
  );
}
